
import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const RedirectRoute = () => {
  const { bookingId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (bookingId) {
      console.log('Redirecting from old URL format to new format for booking:', bookingId);
      navigate(`/management/booking/${bookingId}`, { replace: true });
    }
  }, [bookingId, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="text-center">
        <h1 className="text-xl font-semibold mb-2">Redirecting...</h1>
        <p className="text-gray-600">Please wait while we redirect you to the correct page.</p>
      </div>
    </div>
  );
};

export default RedirectRoute;
